import { combineReducers } from "redux";
import user from "./user/userReducer";
import url from "./authentication/authentication";
import company from "./company/companyReducer";

import { LOGOUT } from "../actions/authentication/authentication";

const appReducer = combineReducers({
  user: user,
  url: url,
  company: company,
});

const urlReducer = (state, action) => {
  if (action.type === LOGOUT) {
    // Wipe all redux state
    state = undefined;
  }

  return appReducer(state, action);
};

export default urlReducer;
